import React from 'react';

interface LoaderProps {
  message?: string;
  fullScreen?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const Loader: React.FC<LoaderProps> = ({
  message = 'Loading...',
  fullScreen = false,
  size = 'medium',
}) => {
  const sizeClasses = {
    small: 'w-8 h-8 border-2',
    medium: 'w-16 h-16 border-4',
    large: 'w-24 h-24 border-4',
  };

  const spinnerClass = `inline-block ${sizeClasses[size]} border-blue-600 border-t-transparent rounded-full animate-spin`;

  const containerClass = fullScreen
    ? 'fixed inset-0 flex flex-col items-center justify-center bg-white bg-opacity-90 z-50'
    : 'flex flex-col items-center justify-center p-8';

  return (
    <div className={containerClass}>
      <div className={spinnerClass} role="status" aria-label="Loading"></div>
      {message && (
        <p className="mt-4 text-gray-700 text-center font-medium">{message}</p>
      )}
    </div>
  );
};

export default Loader;
